



















import {
  defineComponent, PropType, ref, useContext, watch,
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { productUrlConfig } from '~/modules/pdfDownload/getters/productUrl';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'PdfProductUrl',
  components: {
    SfButton,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const { app } = useContext();
    const context = app.$vsf;
    const response = ref();
    const hasDocs = ref(false);

    const downloadPdf = () => {
      if (!response.value?.productPdfUrl) return;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      response.value.productPdfUrl.sort((file) => !file.url.includes('.glb')).forEach((file) => window.open(file.url));
    };

    watch(() => props.product, async () => {
      response.value = await productUrlConfig.execute(context, props.product.sku);
      console.log(response.value);
      hasDocs.value = response.value?.productPdfUrl && response.value?.productPdfUrl.length > 0;
    }, { immediate: true });

    return {
      hasDocs,
      downloadPdf,
    };
  },
});
